
<app-pan-button class="mr-2" color="danger" (click)="onClipNotUsefulClick()" [disabled]="isNotUseful()"> Clip Not Useful </app-pan-button>

<app-pan-modal #modal [topLevel]="false" size="md">
  <div header>Feedback From Video</div>

  <div body class="flex items-center">
    <div class="px-4 py-6 self-center">
      <p class="mb-2">Please state the reason why this video clip is not useful?</p>
      @for (reason of reasons; track reason.value) {
        <div>
          <label class="text-left inline-flex items-center m-1 gap-2">
            <input [checked]="notUsefulReason() === reason.value" (change)="notUsefulReason.set(reason.value)" type="radio" name="notUsefulReason" [value]="reason.value" />
            {{ reason.label }}
          </label>
        </div>
      }
    </div>
  </div>

  <ng-container footer>
    <button panButton panModalClose color="primary" (click)="onSubmit()" [disabled]="!notUsefulReason()">Submit</button>
    <app-pan-button panModalClose>Cancel</app-pan-button>
  </ng-container>
</app-pan-modal>
